<template>
  <BreadCrumb PageTitle="Paramètres du compte" />
  <BankSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import BankSettings from "../../components/Generals/AccountSettings/BankSettings.vue";

export default defineComponent({
  name: "BanksPage",
  components: {
    BreadCrumb,
    BankSettings,
  },
});
</script>